/**
 * Returns the slug equivalent of a given text
 *
 * @param text The text to be converted
 */
export const convertToSlug = (text: string) => text.toLowerCase()
  .replace(/[^\w ]+/g, '')
  .replace(/ +/g, '-');
